"use client";

import { type ReactNode, useState } from "react";
import { type SelectLemma } from "~/server/db/lemmas/schema";
import { type SelectLexeme } from "~/server/db/lexemes/schema";
import { type SelectTranscript } from "~/server/db/transcripts/schema";

import CardFull from "./CardFull";

export type OnShowFullCard = (
  lemma: SelectLemma,
  lexeme?: SelectLexeme,
  transcript?: SelectTranscript,
) => void;

type CardFullContextProps = {
  onShowFullCard: OnShowFullCard;
};

interface CardFullProviderProps {
  children: ((props: CardFullContextProps) => ReactNode) | ReactNode;
  onShowFullCard?: OnShowFullCard;
}

export default function CardFullProvider({
  children,
  onShowFullCard,
}: CardFullProviderProps) {
  const [isFullCardOpen, setIsFullCardOpen] = useState(false);
  const [selectedLexeme, setSelectedLexeme] = useState<SelectLexeme | null>(
    null,
  );
  const [selectedLemma, setSelectedLemma] = useState<SelectLemma | null>(null);
  const [selectedTranscript, setSelectedTranscript] =
    useState<SelectTranscript | null>(null);

  const handleShowFullCard: OnShowFullCard = (lemma, lexeme?, transcript?) => {
    setSelectedLexeme(lexeme ?? null);
    setSelectedLemma(lemma);
    setSelectedTranscript(transcript ?? null);
    setIsFullCardOpen(true);
    onShowFullCard?.(lemma, lexeme, transcript);
  };

  return (
    <>
      <CardFull
        lexeme={selectedLexeme ?? undefined}
        lemma={selectedLemma ?? undefined}
        isOpen={isFullCardOpen}
        onOpenChange={setIsFullCardOpen}
        transcript={selectedTranscript}
      />
      {typeof children === "function"
        ? children({ onShowFullCard: handleShowFullCard })
        : children}
    </>
  );
}
